// import { useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Icon,
// } from "@mui/material";

// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftSelect from "components/SoftSelect";
// import SoftInput from "components/SoftInput";
// import SoftPagination from "components/SoftPagination";

// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";

// import { API_URL } from "config";
// import { getBranches, getShiftsByBranch } from "api/branches";

// function MonthlyAttendanceReport() {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [branches, setBranches] = useState([]);
//   const [shifts, setShifts] = useState([]);

//   const [formData, setFormData] = useState({
//     branch_id: "",
//     shift_id: "",
//     month: "2026-03",
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const perPage = 25;

//   // Load branches
//   useEffect(() => {
//     const loadBranches = async () => {
//       const res = await getBranches(1, 250);
//       setBranches(
//         res?.data?.map((b) => ({
//           label: b.name,
//           value: b.id,
//         })) || []
//       );
//     };
//     loadBranches();
//   }, []);

//   // Load shifts
//   useEffect(() => {
//     if (!formData.branch_id) return;

//     const loadShifts = async () => {
//       const res = await getShiftsByBranch(formData.branch_id);
//       setShifts(
//         res?.data?.map((s) => ({
//           label: `${s.start_time}-${s.end_time}`,
//           value: s.id,
//         })) || []
//       );
//     };
//     loadShifts();
//   }, [formData.branch_id]);

//   // Fetch report
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);

//         const token = localStorage.getItem("authToken");

//         let query = `month=${formData.month}`;

//         if (formData.branch_id) query += `&branch_id=${formData.branch_id}`;
//         if (formData.shift_id) query += `&shift_id=${formData.shift_id}`;

//         const res = await fetch(`${API_URL}/attendance/monthly-report?${query}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const json = await res.json();
//         setData(json.data);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [formData]);

//   const paginatedUsers = data?.users?.slice(
//     (currentPage - 1) * perPage,
//     currentPage * perPage
//   );

//   const totalPages = Math.ceil((data?.users?.length || 0) / perPage);

//   // Format date as "MMM DD ddd"
//   const formatDateHeader = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', weekday: 'short' });
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />

//       <SoftBox p={3}>
//         <Card style={{ padding: "15px" }}>
//           {/* Filters */}
//           <Grid container spacing={2} mb={2}>
//             <Grid item md={3}>
//               <SoftSelect
//                 placeholder="Branch"
//                 options={branches}
//                 onChange={(opt) =>
//                   setFormData((p) => ({ ...p, branch_id: opt?.value }))
//                 }
//               />
//             </Grid>

//             <Grid item md={3}>
//               <SoftSelect
//                 placeholder="Shift"
//                 options={shifts}
//                 onChange={(opt) =>
//                   setFormData((p) => ({ ...p, shift_id: opt?.value }))
//                 }
//               />
//             </Grid>

//             <Grid item md={3}>
//               <SoftInput
//                 type="month"
//                 value={formData.month}
//                 onChange={(e) =>
//                   setFormData((p) => ({ ...p, month: e.target.value }))
//                 }
//               />
//             </Grid>
//           </Grid>

//           {/* Table */}
//           {loading ? (
//             <div className="text-center">Loading...</div>
//           ) : (
//             <div style={{ overflowX: "auto" }}>
//               <table className="table table-bordered" style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   {/* First header row: days with colspan=3 */}
//                   <tr>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Employee</th>
//                     {data.days.map((day) => (
//                       <th key={day} colSpan={3} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>
//                         {formatDateHeader(day)}
//                       </th>
//                     ))}
//                     <th colSpan={10} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Summary</th>
//                   </tr>

//                   {/* Second header row: sub-headers for each day and summary columns */}
//                   <tr>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px" }}></th>
//                     {data.days.map((day) => (
//                       <>
//                         <th key={`${day}-shift`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Shift</th>
//                         <th key={`${day}-status`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Status</th>
//                         <th key={`${day}-details`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Details</th>
//                       </>
//                     ))}
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>P</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>HD</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>PL</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>UL</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>W</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>H</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>A</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Total Days</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Payable</th>
//                     <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Unpayable</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {paginatedUsers.map((user) => {
//                     // Compute totals for PL and UL
//                     const totalPaidLeave = (user.summary.paid_leave_full || 0) + (user.summary.paid_leave_half || 0);
//                     const totalUnpaidLeave = (user.summary.unpaid_leave_full || 0) + (user.summary.unpaid_leave_half || 0);
//                     return (
//                       <tr key={user.user_id}>
//                         <td style={{ fontSize: "10px", padding: "6px", wordBreak: "break-word" }}>{user.name}</td>

//                         {data.days.map((day) => {
//                           const d = user.attendance[day];
//                           return (
//                             <>
//                               <td style={{ fontSize: "10px", padding: "6px", wordBreak: "break-word" }}>{d.shift}</td>
//                               <td style={{ fontSize: "10px", padding: "6px", wordBreak: "break-word" }}>{d.status}</td>
//                               <td style={{ fontSize: "10px", padding: "6px", wordBreak: "break-word" }}>
//                                 {d.details.attendance_start !== "N/A" ? (
//                                   <>
//                                     Start: {d.details.attendance_start?.slice(0, 16) || "N/A"}<br />
//                                     End: {d.details.attendance_end?.slice(0, 16) || "N/A"}<br />
//                                     Min: {d.details.total_minutes}
//                                   </>
//                                 ) : (
//                                   "N/A"
//                                 )}
//                               </td>
//                             </>
//                           );
//                         })}

//                         {/* Summary columns */}
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.present_full}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.present_half}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{totalPaidLeave}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{totalUnpaidLeave}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.weekend_days}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.holidays}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.absent}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.total_days}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.payable_days}</td>
//                         <td style={{ fontSize: "10px", padding: "6px", textAlign: "center" }}>{user.summary.unpayable_days}</td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* Legend */}
//           <SoftBox mt={2} p={1} style={{ backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
//             <SoftTypography variant="body2" style={{ fontSize: "12px" }}>
//               <strong>Status Codes:</strong> P - Present, HD - Half Day, PL - Paid Leave, UL - Unpaid Leave, W - Weekend Off, H - Holiday, A - Absent
//             </SoftTypography>
//           </SoftBox>

//           {/* Pagination */}
//           <SoftBox display="flex" justifyContent="center" mt={2}>
//             <SoftPagination>
//               <SoftPagination
//                 item
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 <Icon>chevron_left</Icon>
//               </SoftPagination>

//               <span style={{ padding: "10px" }}>
//                 {currentPage} / {totalPages}
//               </span>

//               <SoftPagination
//                 item
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 <Icon>chevron_right</Icon>
//               </SoftPagination>
//             </SoftPagination>
//           </SoftBox>
//         </Card>
//       </SoftBox>

//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default MonthlyAttendanceReport;

import { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Icon,
} from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftInput from "components/SoftInput";
import SoftPagination from "components/SoftPagination";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { API_URL } from "config";
import { getBranches } from "api/branches";
// import { getShiftsByBranch } from "api/branches"; // Shift filter disabled

function MonthlyAttendanceReport() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);  // error state

  const [branches, setBranches] = useState([]);
  // const [shifts, setShifts] = useState([]); // Shift filter disabled

  const [formData, setFormData] = useState({
    branch_id: "",
    // shift_id: "", // Shift filter disabled
    month: "2026-03",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 25;

  const [exporting, setExporting] = useState(false);

  // Load branches
  useEffect(() => {
    const loadBranches = async () => {
      const res = await getBranches(1, 250);
      setBranches(
        res?.data?.map((b) => ({
          label: b.name,
          value: b.id,
        })) || []
      );
    };
    loadBranches();
  }, []);

  // Load shifts - DISABLED SHIFT FILTER
  // useEffect(() => {
  //   if (!formData.branch_id) return;
  //
  //   const loadShifts = async () => {
  //     const res = await getShiftsByBranch(formData.branch_id);
  //     setShifts(
  //       res?.data?.map((s) => ({
  //         label: `${s.start_time}-${s.end_time}`,
  //         value: s.id,
  //       })) || []
  //     );
  //   };
  //   loadShifts();
  // }, [formData.branch_id]);

  // Fetch report
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem("authToken");

        let query = `month=${formData.month}`;

        if (formData.branch_id) query += `&branch_id=${formData.branch_id}`;
        // if (formData.shift_id) query += `&shift_id=${formData.shift_id}`; // Shift filter disabled

        const fullUrl = `${API_URL}/attendance/monthly-report?${query}`;
        console.log("🔍 API Call:", fullUrl);
        console.log("📦 Form Data:", formData);

        const res = await fetch(fullUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }

        const json = await res.json();
        setData(json.data);
      } catch (e) {
        console.error(e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [formData]);

  const paginatedUsers = data?.users?.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const totalPages = Math.ceil((data?.users?.length || 0) / perPage);

  // Format date as "MMM DD ddd"
  const formatDateHeader = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', weekday: 'short' });
  };

  // const handleExport = async () => {
  //   try {
  //     const token = localStorage.getItem("authToken");

  //     let query = `month=${formData.month}`;

  //     if (formData.branch_id) query += `&branch_id=${formData.branch_id}`;

  //     const url = `${API_URL}/attendance/monthly-export?${query}`;

  //     console.log("📥 Export URL:", url);

  //     const response = await fetch(url, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error("Export failed");
  //     }

  //     const blob = await response.blob();

  //     const link = document.createElement("a");
  //     link.href = window.URL.createObjectURL(blob);

  //     link.download = `attendance_${formData.month}.xlsx`;

  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();

  //   } catch (err) {
  //     console.error(err);
  //     alert("Export failed");
  //   }
  // };

  const handleExport = async () => {
    try {
      setExporting(true); // ✅ START LOADER

      const token = localStorage.getItem("authToken");

      let query = `month=${formData.month}`;

      if (formData.branch_id) query += `&branch_id=${formData.branch_id}`;

      const url = `${API_URL}/attendance/monthly-export?${query}`;

      console.log("📥 Export URL:", url);

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Export failed");
      }

      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `attendance_${formData.month}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (err) {
      console.error(err);
      alert("Export failed");
    } finally {
      setExporting(false); // ✅ STOP LOADER
    }
  };

  // Helper to format leave object/array into list of strings like "SL: 1"
  const formatLeaveList = (leaveData) => {
    if (!leaveData) return [];

    // Case 1: Array of leave codes ["SL", "CL", "SL"]
    if (Array.isArray(leaveData)) {
      const counts = {};
      leaveData.forEach(code => counts[code] = (counts[code] || 0) + 1);
      return Object.entries(counts).map(([code, count]) => `${code}: ${count}`);
    }

    // Case 2: Object like {"SL": 1, "CL": 2}
    if (typeof leaveData === "object") {
      return Object.entries(leaveData)
        .filter(([_, count]) => count > 0)
        .map(([code, count]) => `${code}: ${count}`);
    }

    return [];
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox p={3}>
        <Card style={{ padding: "15px" }}>
          {/* Filters */}
          <Grid container spacing={2} mb={2}>
            <Grid item md={3}>
              <SoftSelect
                placeholder="Branch"
                options={branches}
                onChange={(opt) =>
                  setFormData((p) => ({ ...p, branch_id: opt?.value }))
                }
              />
            </Grid>

            {/* <Grid item md={3}>
              <SoftSelect
                placeholder="Shift"
                options={shifts}
                onChange={(opt) =>
                  setFormData((p) => ({ ...p, shift_id: opt?.value }))
                }
              />
            </Grid> */}

            <Grid item md={3}>
              <SoftInput
                type="month"
                value={formData.month}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, month: e.target.value }))
                }
              />
            </Grid>
          </Grid>
          <Grid item md={3}>
            {/* <button
              onClick={handleExport}
              style={{
                padding: "10px 15px",
                background: "#344767",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                width: "100%"
              }}
            >
              Export
            </button> */}
            <button
              onClick={handleExport}
              disabled={exporting}
              style={{
                padding: "10px 15px",
                background: exporting ? "#999" : "#344767",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: exporting ? "not-allowed" : "pointer",
                width: "100%"
              }}
            >
              {exporting ? "Exporting..." : "Export"}
            </button>
          </Grid>

          {/* Table */}
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : error ? (
            <div className="text-center text-danger">Error: {error}</div>
          ) : !data ? (
            <div className="text-center">No data available</div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Employee</th>
                    {data.days.map((day) => (
                      <th key={day} colSpan={2} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>
                        {formatDateHeader(day)}
                      </th>
                    ))}
                    <th colSpan={9} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Summary</th>
                  </tr>
                  <tr>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px" }}></th>
                    {data.days.map((day) => (
                      <>
                        {/* <th key={`${day}-shift`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Shift</th> */}
                        <th key={`${day}-status`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Status</th>
                        <th key={`${day}-details`} style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Details</th>
                      </>
                    ))}
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>P</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>HD</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>PL</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>UL</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>W</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>H</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>A</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Total Days</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Payable</th>
                    <th style={{ fontSize: "12px", fontWeight: "normal", padding: "8px", whiteSpace: "nowrap" }}>Unpayable</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedUsers.map((user) => {
                    // const totalPaidLeave = (user.summary.paid_leave_full || 0) + (user.summary.paid_leave_half || 0);
                    // const totalUnpaidLeave = (user.summary.unpaid_leave_full || 0) + (user.summary.unpaid_leave_half || 0);
                    // Get formatted leave list as array of strings
                    const paidLeaveItems = formatLeaveList(user.summary.paid_leaves);
                    if (user.summary.paid_leave_half?.length) {
                      paidLeaveItems.push(`HD: ${user.summary.paid_leave_half.length}`);
                    }

                    const unpaidLeaveItems = formatLeaveList(user.summary.unpaid_leaves);
                    if (user.summary.unpaid_leave_half?.length) {
                      unpaidLeaveItems.push(`HD: ${user.summary.unpaid_leave_half.length}`);
                    }

                    return (
                      <tr key={user.user_id}>
                        <td style={{ fontSize: "10px", padding: "6px", wordBreak: "break-word" }}>{user.name}</td>

                        {data.days.map((day) => {
                          const d = user.attendance[day];
                          return (
                            <>
                              {/* <td style={{ fontSize: "10px", padding: "6px", whiteSpace: "nowrap" }}>{d.shift}</td> */}
                              <td style={{ fontSize: "10px", padding: "6px", whiteSpace: "nowrap" }}>{d.status}</td>
                              {/* <td style={{ fontSize: "10px", padding: "6px", whiteSpace: "nowrap" }}>
                                {d.details.attendance_start !== "N/A" ? (
                                  `S:${d.details.attendance_start?.slice(0, 16) || "N/A"} E:${d.details.attendance_end?.slice(0, 16) || "N/A"} M:${d.details.total_minutes}`
                                ) : (
                                  "N/A"
                                )}
                              </td> */}
                              <td style={{ fontSize: "10px", padding: "6px", whiteSpace: "nowrap" }}>
                                {d.details.attendance_start !== "N/A" ? (
                                  <>
                                    S:{d.details.attendance_start?.slice(0, 16) || "N/A"}<br />
                                    E:{d.details.attendance_end?.slice(0, 16) || "N/A"}<br />
                                    M:{d.details.total_minutes}
                                  </>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                            </>
                          );
                        })}

                        {/* Summary columns */}
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.present_full}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.present_half}</td>
                        {/* <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{totalPaidLeave}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{totalUnpaidLeave}</td> */}
                        {/* PL Column */}
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "left", whiteSpace: "nowrap" }}>
                          {paidLeaveItems.length > 0 ? (
                            paidLeaveItems.map((item, idx) => (
                              <div key={idx}>{item}</div>
                            ))
                          ) : (
                            "0"
                          )}
                        </td>

                        {/* UL Column */}
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "left", whiteSpace: "nowrap" }}>
                          {unpaidLeaveItems.length > 0 ? (
                            unpaidLeaveItems.map((item, idx) => (
                              <div key={idx}>{item}</div>
                            ))
                          ) : (
                            "0"
                          )}
                        </td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.weekend_days}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.holidays}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.absent}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.total_days}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.payable_days}</td>
                        <td style={{ fontSize: "10px", padding: "6px", textAlign: "center", whiteSpace: "nowrap" }}>{user.summary.unpayable_days}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Legend */}
          <SoftBox mt={2} p={1} style={{ backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
            <SoftTypography variant="body2" style={{ fontSize: "12px" }}>
              <strong>Status Codes:</strong> P - Present, HD - Half Day, PL - Paid Leave, UL - Unpaid Leave, W - Weekend Off, H - Holiday, A - Absent
            </SoftTypography>
          </SoftBox>

          {/* Pagination */}
          <SoftBox display="flex" justifyContent="center" mt={2}>
            <SoftPagination>
              <SoftPagination
                item
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <Icon>chevron_left</Icon>
              </SoftPagination>

              <span style={{ padding: "10px" }}>
                {currentPage} / {totalPages}
              </span>

              <SoftPagination
                item
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <Icon>chevron_right</Icon>
              </SoftPagination>
            </SoftPagination>
          </SoftBox>
        </Card>
      </SoftBox>

      <Footer />
    </DashboardLayout>
  );
}

export default MonthlyAttendanceReport;